var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"item-weexImg",style:(_vm.styles),attrs:{"src":_vm.detail.src,"alt":""},on:{"click":_vm.onNavigation}})
}
var staticRenderFns = []

export { render, staticRenderFns }